module.exports = __webpack_public_path__ + "media/images/product_lines/motorcycle/h1-67dc75370c48a679acc5074156d02120.svg";